import { createSlice } from '@reduxjs/toolkit'

import {
  addLiveDataEntry,
  deleteLiveDataEntry,
  updateLiveDataEntry,
} from 'apps/formsCreationKit/store/actions/sharedActions'

import { saveApp } from 'apps/formsCreationKit/store/reducers/settings/appSettings'

import { updateEntry } from 'apps/formsCreationKit/store/actions/sharedActions'
import { actions as clientActions } from '@gocanvas/client'
const { loadFormData } = clientActions


export const initialState = []

const ensureContextExists = (state, action) => {
  const {
    live_data_source_id,
    data_source_context_id,
    dataContextLabel,
    dependent_entry
  } = action.payload
  const { data_source_context_id: dependentDataSourceContextId } = dependent_entry || {}
  const dataSourceContextIdToCheck = dependentDataSourceContextId || data_source_context_id

  const existingContext = state.find(
    context =>
      context.live_data_source_id === live_data_source_id &&
      context.id === dataSourceContextIdToCheck
  )

  if (existingContext || !dataSourceContextIdToCheck) return state

  const newContext = {
    id: data_source_context_id,
    live_data_source_id,
    label: dataContextLabel || 'Default Context',
  }
  return [...state, newContext]
}

export const dataSourceContext = createSlice({
  name: 'dataSourceContext',
  initialState,
  reducers: {
    removeDataSourceContext(state, action) {
      return state.filter(context => context.id !== action.payload.id)
    },
    updateDataSourceContext(state, action) {
      const { id, label } = action.payload
      return state.map(context => {
        if (context.id !== id) return context
        return {
          ...context,
          label,
        }
      })
    },
  },
  extraReducers: builder => {
    builder.addCase(loadFormData, (state, action) => {
      const { dataSourceContexts = [] } = action.payload
      return dataSourceContexts
    })
    builder.addCase(addLiveDataEntry, ensureContextExists)
    builder.addCase(updateLiveDataEntry, ensureContextExists)
    builder.addCase(deleteLiveDataEntry, (state, action) => {
      const { data_source_context_id } = action.payload
      return state.filter(context => context.id !== data_source_context_id)
    })
    builder.addCase(updateEntry, (state, action) => {
      const { check_data_source_context } = action.payload

      if (!check_data_source_context) return state

      return ensureContextExists(state, action) 
    })
    builder.addCase(saveApp.fulfilled, (state, action) => {
      const { data_source_contexts = [] } = action.payload
      
      return data_source_contexts
    })
  },
})

export const { actions, reducer } = dataSourceContext
export default reducer
